// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"TagScreen_buttonsContainer__5kWit","button":"TagScreen_button__rBbkX"};